import { render, staticRenderFns } from "./video-player-modal.vue?vue&type=template&id=2be90251&"
import script from "./video-player-modal.vue?vue&type=script&lang=ts&"
export * from "./video-player-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports